// extracted by mini-css-extract-plugin
module.exports = {"IconWithCounter":"IconWithCounter_IconWithCounter__3Lxsl","counter":"IconWithCounter_counter__3GN6i"};